<div class="ratings-wrapper">
  <h2 class="section-title">Customers Feedback</h2>

  <!-- Summary Box & Bars -->
  <div class="feedback-summary">
    <div class="rating-card">
      <div class="score">{{ averageRating() | number: '1.1-1' }}</div>
      <div class="stars-display">
        <i class="fas fa-star filled" *ngFor="let s of getStarArray(averageRating())"></i>
      </div>
      <div class="score-label">Product Rating</div>
    </div>

    <div class="rating-bars">
      <div class="bar-row" *ngFor="let stat of ratingStats()">
        <div class="stars-label">
          <i class="fas fa-star filled" *ngFor="let s of getStarArray(stat.stars)"></i>
        </div>
        <div class="progress-track">
          <div class="progress-fill" [style.width.%]="stat.percentage"></div>
        </div>
        <div class="percent-label">{{ stat.percentage | number: '1.0-0' }}%</div>
      </div>
    </div>
  </div>

  <!-- Add Review Section -->
  <div class="add-review-section">
    <h3 class="subsection-title">Leave a Review</h3>

    <div class="star-selector">
      <span class="instruction">Rating:</span>
      <i
        class="fas fa-star interactive"
        *ngFor="let s of [1, 2, 3, 4, 5]"
        [class.active]="s <= userRating()"
        (click)="userRating.set(s)"
      ></i>
    </div>

    <div class="review-form">
      <div class="input-group">
        <input type="text" placeholder="Your Name" [(ngModel)]="userName" class="review-input" />
      </div>
      <div class="input-group">
        <input
          type="email"
          placeholder="Your Email *"
          [(ngModel)]="userEmail"
          class="review-input"
        />
      </div>
      <!-- <div class="input-group">
        <textarea placeholder="Your Comments" [(ngModel)]="userComments" class="review-input" rows="4"></textarea>
      </div> -->
      <button class="btn-submit-review" [disabled]="!canSubmit()" (click)="submitReview()">
        {{ isSubmitting() ? 'Submitting...' : 'Submit Rating' }}
      </button>
    </div>

    <div class="success-message" *ngIf="submitSuccess()">
      <i class="fas fa-check-circle"></i> Thank you! Your rating has been submitted successfully.
    </div>
  </div>

  <!-- Reviews List -->
  <div class="reviews-list" *ngIf="reviews.length > 0">
    <h3 class="subsection-title">Recent Feedback</h3>
    <div class="review-item" *ngFor="let review of reviews">
      <div class="rev-header">
        <div class="rev-avatar"><i class="fas fa-user"></i></div>
        <div class="rev-meta">
          <span class="rev-name">{{ review.name || review.reviewerName || 'Anonymous' }}</span>
          <div class="rev-stars">
            <i
              class="fas fa-star filled"
              *ngFor="let s of getStarArray(review.rating || review.stars || 0)"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
